export const Color = {
	themeColor: "#f97316",
	success: "#f97316",
};
